import script from "./TestAgentView.vue?vue&type=script&setup=true&lang=js"
export * from "./TestAgentView.vue?vue&type=script&setup=true&lang=js"

import "./TestAgentView.vue?vue&type=style&index=0&id=5820b925&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5820b925"]])

export default __exports__